import { jsx as L } from "react/jsx-runtime";
function e(t) {
  return /* @__PURE__ */ L("svg", { fill: "none", height: "24", viewBox: "0 0 24 24", width: "24", xmlns: "http://www.w3.org/2000/svg", ...t, children: /* @__PURE__ */ L(
    "path",
    {
      d: "M14.0941 10.3155L22.2883 1H20.3465L13.2315 9.08852L7.54876 1H0.994385L9.58782 13.2313L0.994385 23H2.93626L10.4499 14.4583L16.4513 23H23.0057L14.0936 10.3155H14.0941ZM11.4344 13.339L10.5637 12.1211L3.63594 2.42965H6.61855L12.2094 10.2509L13.0801 11.4689L20.3475 21.6354H17.3648L11.4344 13.3395V13.339Z",
      fill: "white"
    }
  ) });
}
export {
  e as default
};
